import {
  COMPLAINT_LIST_INITIATED,
  COMPLAINT_INITIATED,
  COMPLAINT_LIST_LOADED,
  COMPLAINT_LOADED,
  COMPLAINT_FAILED,
  COMPLAINT_REPLIES_INITIATED,
  COMPLAINT_REPLIES_LOADED,
  COMPLAINT_REPLY_ADDED,
} from '../actions/ComplaintsAction';

const initialState = {
  listdata: [],
  data: {},
  replies: [],
  pagination: {
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 1,
    nextPage: null,
  },
  loading: false,
  error: null,
};

const normalizeNulls = (obj) =>
  obj && typeof obj === 'object'
    ? Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, v == null ? '' : v]))
    : obj;

const getId = (x) => x?.id ?? x?.replyId ?? x?.reply_id ?? null;
const getTime = (x) => {
  const t = x?.createdAt ?? x?.created_at ?? null;
  return t ? new Date(t).getTime() : 0;
};

const ComplaintsReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPLAINT_LIST_INITIATED:
      return { ...state, data: {}, loading: true, error: null };

    case COMPLAINT_LIST_LOADED: {
      const payload = action.payload || [];
      const listRaw = Array.isArray(payload) ? payload : payload.data || [];
      const list = listRaw.map(normalizeNulls);
      const pagination = Array.isArray(payload) ? state.pagination : payload.pagination || state.pagination;
      return { ...state, loading: false, data: {}, listdata: list, pagination, error: null };
    }

    case COMPLAINT_INITIATED:
      return { ...state, loading: true, error: null };

    case COMPLAINT_LOADED: {
      const raw = Array.isArray(action.payload) ? action.payload[0] : action.payload;
      const item = normalizeNulls(raw) || {};
      let listdata = state.listdata;
      if (item && item.id) {
        const idx = state.listdata.findIndex((x) => x.id === item.id);
        if (idx === -1) {
          listdata = [item, ...state.listdata];
        } else {
          listdata = [
            ...state.listdata.slice(0, idx),
            { ...state.listdata[idx], ...item },
            ...state.listdata.slice(idx + 1),
          ];
        }
      }
      return { ...state, loading: false, data: item, listdata, error: null };
    }

    case COMPLAINT_REPLIES_INITIATED:
      return { ...state, error: null };

    case COMPLAINT_REPLIES_LOADED: {
      const rows = Array.isArray(action.payload) ? action.payload : action.payload?.data || [];
      const replies = rows.map(normalizeNulls).sort((a, b) => getTime(a) - getTime(b));
      return { ...state, replies, error: null };
    }

    case COMPLAINT_REPLY_ADDED: {
      const incomingArr = Array.isArray(action.payload) ? action.payload : [action.payload];
      const incoming = incomingArr.map(normalizeNulls);
      const map = new Map(state.replies.map((r) => [getId(r), r]));
      incoming.forEach((r) => {
        const id = getId(r);
        if (id != null) map.set(id, { ...(map.get(id) || {}), ...r });
        else map.set(Symbol('tmp'), r);
      });
      const replies = Array.from(map.values()).sort((a, b) => getTime(a) - getTime(b));
      return { ...state, loading: false, replies, error: null };
    }

    case COMPLAINT_FAILED:
      return { ...state, loading: false, error: action.payload, listdata:[]  };

    default:
      return state;
  }
};

export default ComplaintsReducer;
